import { render, staticRenderFns } from "./choosePartnerGoods.vue?vue&type=template&id=d88eaa10&scoped=true"
import script from "./choosePartnerGoods.vue?vue&type=script&lang=js"
export * from "./choosePartnerGoods.vue?vue&type=script&lang=js"
import style0 from "./choosePartnerGoods.vue?vue&type=style&index=0&id=d88eaa10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88eaa10",
  null
  
)

export default component.exports